/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, {useState, useEffect, useCallback} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faHome, faSearch, faTools } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup, Dropdown, Card } from '@themesberg/react-bootstrap';

import { TransactionsTable } from "../../components/Tables";
import { GetResultObject, PostRequest } from "../../core/API";
import { ApiSrc } from "../../resources/ApiSrc";

export default () => {

  const [isNew, setIsNew] = useState()  
  const [settingList, setSettingList] = useState()  

  useEffect(()=>{
      PostRequest(ApiSrc.GET_SETTING, {input: {

      }}).then(result => {
        GetResultObject(result, 'data', 200, (data) => {
            setSettingList(data)
        })
      })
  }, [])

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">          
          <h4>System Settings</h4>          
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm" onClick={()=>{setIsNew(true)}}>New</Button>
            <Button variant="outline-primary" size="sm">Export</Button>
          </ButtonGroup>
        </div>
      </div>

      <Card>
        <Card.Body>
            <Row>
                <Col xs={12} sm={6} xl={6}>
                    {
                        settingList && (
                            settingList.map(item => {
                                return (
                                    <Form.Group className="mb-4">
                                    <Form.Label>{ _.get(item, 'description') }</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faTools} />
                                        </InputGroup.Text>
                                        <Form.Control
                                            autoFocus={true}                                          
                                            //onChange={accountNoPress}
                                            //onChange={(e) => { setAccountNo(e.target.value) }}
                                            //onChange={(e) => { setAccountNo(e.target.value) }}
                                            value={ _.get(item, 'value') }
                                        />
                                    </InputGroup>
                                </Form.Group>  
                                )
                            })
                        )
                    }
                </Col>
            </Row>
        </Card.Body>
      </Card>
      
    </>
  );
};
